import React, { useMemo } from 'react';
import NavListItem from './nav-list-item';

interface SelectedNavType {
  select: string;
  subSelect: string;
}

/** 去掉 /v2 base 前缀，兼容 hash 路由下的 pathname */
const normalizeNavPath = (path: string): string => {
  const lowerPath = path.toLowerCase();
  return lowerPath.startsWith('/v2/') ? lowerPath.slice(3) : lowerPath;
};

/** 安全 decode，兼容 pathname 与 sys 一侧编码、一侧原文的情况 */
const safeDecodeURIComponent = (value: string): string => {
  try {
    return decodeURIComponent(value);
  } catch {
    return value;
  }
};

/**
 * 判断路径是否匹配导航 sys。
 * 使用路径段边界匹配，避免 /studio/miniclip 误匹配 /studio/miniclip_derby。
 */
const isNavPathMatch = (path: string, sys: string): boolean => {
  if (!path || !sys) return false;
  const normalizedPath = safeDecodeURIComponent(normalizeNavPath(path)).toLowerCase();
  const normalizedSys = safeDecodeURIComponent(sys).toLowerCase();
  if (!normalizedPath.startsWith(normalizedSys)) return false;
  const nextChar = normalizedPath[normalizedSys.length];
  return nextChar === undefined || nextChar === '/';
};

// 存储上次访问的系统
let selectInfoRef: SelectedNavType = {
  select: 'homepage_pc',
  subSelect: ''
};

// const homePathList = ['/chatgpt'];

export default function NavList(props: any) {
  const { list = [], defaultValue = '', clickSubMenu, clickMenu, isAIToolClicked } = props;
  // 头部当前选择的导航
  const selectInfo: SelectedNavType = useMemo(() => {
    // 如果当前页面是AI 工具 导航就为空，并清空上次访问的系统
    if (isAIToolClicked) {
      selectInfoRef = { select: '', subSelect: '' };
      return { select: '', subSelect: '' };
    }  
    let select = '';
    let subSelect = '';
    if (defaultValue && list?.length > 0) {
      list.some((item: any) => {
        const { sys, rbac, children = [] } = item;
        if (children.length > 0) {
          return children.some((subItem: any) => {
            const { sys, rbac: subRbac } = subItem;
            if (isNavPathMatch(defaultValue, sys)) {
              select = rbac;
              subSelect = subRbac;
              selectInfoRef = {
                select,
                subSelect
              };
              return true;
            }

          });
        }
        if (isNavPathMatch(defaultValue, sys)) {
          select = rbac;
          selectInfoRef = {
            select,
            subSelect
          };
          return true;
        }
        return false;
      });
    }

    // 展示home
    // if (homePathList.includes(defaultValue)) {
    //   selectInfoRef = {
    //     select: 'homepage_pc',
    //     subSelect: ''
    //   }
    // }

    const selectedNav: SelectedNavType = { ...selectInfoRef };
    return selectedNav;
  }, [defaultValue, isAIToolClicked, list]);
  const { select, subSelect } = selectInfo;

  return list.map((item: any) =>
    <NavListItem
      key={item.rbac}
      item={item}
      select={select}
      subSelect={subSelect}
      clickSubMenu={clickSubMenu}
      clickMenu={clickMenu}
    />);
}
